import { render, staticRenderFns } from "./bFloorShop.vue?vue&type=template&id=2a9d307a&scoped=true"
import script from "./bFloorShop.vue?vue&type=script&lang=js"
export * from "./bFloorShop.vue?vue&type=script&lang=js"
import style0 from "./bFloorShop.vue?vue&type=style&index=0&id=2a9d307a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9d307a",
  null
  
)

export default component.exports